// extracted by mini-css-extract-plugin
export var formContainer = "_dy-0";
export var message = "_dy-1";